module.exports = __webpack_public_path__ + "img/mile5m-m@2.48bc50d2.webp";